import React, { useState } from "react";
import LogsTable from "./LogsTable";
import LogsHeader from "./LogsHeader";
import svg41 from "../../assets/svg/svg41.svg";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../layout/BreadCrumb";

function LogsList() {
  const navigate =  useNavigate()
  const [filters, setFilters] = useState({});

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleBack = () => {
    navigate(-1);
  };
  return (
    <div>
      <BreadCrumb breadcrumbs={[{ title: "Logs" }]} />
      <LogsHeader onFiltersChange={handleFiltersChange} />
      <LogsTable filters={filters} />
    </div>
  );
}

export default LogsList;
